import { api_host, api_auth, CLIENTE_ID_BCH } from '../../common/globals/constants';

const HASH = '3276bd408a114308ab00c6133fe29fb2';
const ENDPOINT = '/reporte/online/indicadores/dataAvailability/';

const buildUrl = (type, params = {}) => {
  const user = sessionStorage.getItem('user');
  const token = sessionStorage.getItem('key');
  const searchParams = new URLSearchParams({
    user,
    key: api_auth,
    token,
    hash: HASH,
    type,
    clienteId: CLIENTE_ID_BCH,
    clienteUsuarioId: user,
    formato: 'json',
    ...params,
  });
  return `${api_host}${ENDPOINT}?${searchParams.toString()}`;
};

/**
 * Disponibilidad y tiempos de respuesta (diario/mensual/anual)
 * @param {string} fecha - "2026-01-01" o "2026-01-01,2026-03-01"
 * @param {object} [params] - Parámetros opcionales: canal, tipo_servicio, objetivo_id, cliente_id, etc.
 */
export const getDisponibilidad = async (fecha, params = {}) => {
  const response = await fetch(buildUrl('disponibilidad', { fecha, ...params }));
  return response.json();
};

/**
 * Incidentes asociados al banco de chile
 * @param {string} fecha - "2026-01-01" o "2026-01-01,2026-03-01"
 * @param {object} [params] - Parámetros opcionales: objetivo_id, canal, etc.
 */
export const getIncidentes = async (fecha, params = {}) => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 60000);
  try {
    const response = await fetch(
      buildUrl('incidentes', { fecha, ...params }),
      { signal: controller.signal }
    );
    return response.json();
  } finally {
    clearTimeout(timeoutId);
  }
};

/**
 * Disponibilidad con granularidad horaria
 * @param {string} fecha - "2025-03-01,2025-03-31"
 * @param {object} [params] - Parámetros opcionales: canal, tipo_servicio, etc.
 */
export const getDisponibilidadHora = async (fecha, params = {}) => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 120000);
  try {
    const response = await fetch(
      buildUrl('disponibilidad', { fecha, agrupacion: 'hora', ...params }),
      { signal: controller.signal }
    );
    return response.json();
  } finally {
    clearTimeout(timeoutId);
  }
};
